import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";

export const initEminogluGallery = (): void => {
  const galleries = document.querySelectorAll<HTMLElement>(
    "[data-gallery-filter]",
  );
  if (galleries.length === 0) return;

  galleries.forEach((gallery) => {
    // 1. Initialize PhotoSwipe Lightbox
    const lightbox = new PhotoSwipeLightbox({
      gallery: gallery.querySelector(".eminoglu-gallery__grid") as HTMLElement,
      children: ".eminoglu-gallery__image-link:not(.is-hidden-by-filter)", // Only allow clicking visible items
      pswpModule: () => import("photoswipe"),
    });
    lightbox.init();

    // 2. Filter Logic
    const tabBtns = gallery.querySelectorAll<HTMLButtonElement>(
      ".eminoglu-gallery__tab-btn",
    );
    const gridItems = gallery.querySelectorAll<HTMLElement>(
      ".eminoglu-gallery__item",
    );

    tabBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        tabBtns.forEach((b) => b.classList.remove("is-active"));
        btn.classList.add("is-active");

        const filterValue = btn.getAttribute("data-filter");

        gridItems.forEach((item) => {
          const link = item.querySelector(".eminoglu-gallery__image-link");
          const itemCategory = item.getAttribute("data-category");

          if (filterValue === "all" || filterValue === itemCategory) {
            item.classList.remove("is-hidden");
            link?.classList.remove("is-hidden-by-filter"); // Tell Lightbox it's clickable
            setTimeout(() => {
              item.style.opacity = "1";
              item.style.transform = "scale(1)";
            }, 10);
          } else {
            item.style.opacity = "0";
            item.style.transform = "scale(0.95)";
            link?.classList.add("is-hidden-by-filter"); // Tell Lightbox to ignore it
            setTimeout(() => {
              item.classList.add("is-hidden");
            }, 400);
          }
        });
      });
    });
  });
};
